import {useMemo} from "react";
import {Color} from "finhelper";

function useChartData(preparedActives: any[] | undefined) {
    return useMemo(() => {
        // Уровень 1: Основные категории
        const level1Map = new Map<string, {
            name: string;
            color: any;
            value: number;
            children: any[];
        }>();

        // Уровень 2: Подкатегории
        const level2Map = new Map<string, Map<string, {
            name: string;
            color: any;
            value: number;
            children: any[];
            parent: string;
        }>>();

        if (!Array.isArray(preparedActives)) return [];

        for (const year of preparedActives) {
            const months = year?.months || [];
            for (const month of months) {
                const dates = month?.dates || [];
                for (const date of dates) {
                    const items = date?.items || [];
                    for (const op of items) {
                        const mainCategory = String(op?.category_text ?? '');
                        const subCategory = String(op?.subcategory_text ?? mainCategory);
                        const itemName = String(op?.name ?? subCategory);
                        const value = Math.abs(op?.sum || op?.value || 0);

                        const color = Color.getColorByCategory({
                            name: op?.category_text,
                            color: op?.color
                        });

                        // Уровень 1: Основная категория
                        if (!level1Map.has(mainCategory)) {
                            level1Map.set(mainCategory, {
                                name: mainCategory,
                                color: color,
                                value: 0,
                                children: [],
                            });
                        }
                        const level1 = level1Map.get(mainCategory)!;
                        level1.value += value;

                        // Уровень 2: Подкатегория
                        if (!level2Map.has(mainCategory)) {
                            level2Map.set(mainCategory, new Map());
                        }
                        const subMap = level2Map.get(mainCategory)!;

                        if (!subMap.has(subCategory)) {
                            subMap.set(subCategory, {
                                name: subCategory,
                                color: color,
                                value: 0,
                                children: [],
                                parent: mainCategory,
                            });
                        }
                        const level2 = subMap.get(subCategory)!;
                        level2.value += value;

                        // Уровень 3: Конкретные элементы
                        level2.children.push({
                            name: itemName,
                            value: value,
                            color: color,
                            parent: subCategory,
                        });
                    }
                }
            }
        }

        // Собираем структуру
        const result: any[] = [];
        level1Map.forEach((level1Data, mainCategory) => {
            const subMap = level2Map.get(mainCategory);
            if (subMap) {
                level1Data.children = Array.from(subMap.values());
            }
            result.push(level1Data);
        });

        return result;
    }, [preparedActives]);
}

export default useChartData;